import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-home-icon',
  template: `
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19.2402H9V13.2402H15V19.2402H18V10.2402L12 5.74023L6 10.2402V19.2402ZM4 21.2402V9.24023L12 3.24023L20 9.24023V21.2402H13V15.2402H11V21.2402H4Z"
        [attr.fill]="'currentColor'"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeIconComponent {}
